import { ABaseModel } from '@pperform/pp-data-mappers';

export class Campaign extends ABaseModel {
  uuid = '';

  name = '';

  placement = '';

  imageUrl = '';

  redirectUrl = '';
}
